<template>
  <div class="App_Footer">
    <br />
    <span>老刘承诺：本站代码长期维护有效，可修改，可加减页面。</span><br />
    <p>© Copyright 刘师傅的代码</p>
    <div class="beian">
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61048102000180"
        ><img src="../assets/备案图标.png" style="float: left" />
        <p>陕公网安备 61048102000180号</p></a
      >
    </div>
    <div class="wx">
      <img src="../assets/wx-img.jpg" alt="vx114322" />
      <span>添加老刘微信</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopdmGongan",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.App_Footer {
  padding: 10px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .beian {
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    a {
      display: inline-block;
      text-decoration: none;
      height: 20px;
      line-height: 20px;
      p {
        float: left;
        height: 20px;
        line-height: 20px;
        margin: 0px 0px 0px 5px;
        color: #939393;
      }
    }
  }
  span,
  p {
    text-align: center;
    color: #333;
  }
  & > .wx {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      height: 100px;
      width: 100px;
    }
    span {
      font-weight: bold;
      color: #666 !important;
    }
  }
}
</style>
